import { Injectable } from '@angular/core';

import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IRoom } from './live-viewer.model';
import { environment } from '../../environments/environment';

type EntityResponseType = HttpResponse<IRoom>;

@Injectable({ providedIn: 'root' })
export class RoomService {
    showProduct = false;

    private baseUrl;
    private projectId;
    constructor(protected http: HttpClient
    ) {
        this.baseUrl = environment.serviceUrl;
        this.projectId = environment.projectId;
    }

    find(id: string): Observable<EntityResponseType> {
        let url = `${this.baseUrl}/bifrost/api/live/projects/${this.projectId}/rooms/${id}`;

        return this.http.get<IRoom>(url, {
            headers: {},
            observe: 'response'
        });
    }

    toggleShowProduct(): boolean {
        this.showProduct = true ;
        return this.showProduct;
    }

    toggleCloseProduct(): boolean {
        this.showProduct = false;
        console.log(this.showProduct);
        return this.showProduct;
    }

    getProduct(): boolean {
        return this.showProduct;
    }

}
